import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";

const DeleteButton = ({ onClick, label }) => {
  const { t } = useTranslation();
  return (
    <IconButton
      onClick={onClick}
      variant="contained"
      color="primary"
      sx={{
        padding: "8px 16px 8px 12px",
        height: "40px",
        display: "inline-flex",
        flexShrink: 0,
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: "8px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "normal",
        borderRadius: "6px",
        backgroundColor: "#FFFF",
        border: "1px solid var(--main-color)",
        color: "var(--main-color)",
        textTransform: "none",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          border: "1px solid var(--secondary-color)",
          color: "#FFF",
          backgroundColor: "var(--secondary-color)",
        },
      }}
    >
      {label || t("dataModelDetail.delete")}
      <DeleteIcon />
    </IconButton>
  );
};

export default DeleteButton;
